export const API_URL = IS_PRODUCTION ? "/api" : "/api";
export const API_URL_SHOP = IS_PRODUCTION ? "/shop" : "/shop";
export const API_URL_OFFICE = IS_PRODUCTION ? "/office" : "/office";
export const KEYCLOAK = {
    url: 'https://auth.open-diakonie.de',
    realm: 'OpenDiakonie',
    clientId: 'rudiDesk'
};
export const DEBUG = !IS_PRODUCTION;
export const DEFAULT_PREFS = {
    logInteraction: false,
    favorites: [],
    theme: 'theme-default'
};
export const RESTRICTED_MAIL_DOMAINS = [
    'open-diakonie.de',
    'rummelsberger.net',
    'autismus-mittelfranken.de',
    'panini-ggmbh.de',
    'capito-nordbayern.de',
    'meinrummelsberg.de',
    'hbk-bayreuth.de',
    'pflegedienst-otto.de',
    'ra.com'
];
export const KEYCLOAK_ACCOUNT_URI = "https://auth.open-diakonie.de/realms/OpenDiakonie/account";
